import axios from "axios";

const apiURL = "https://api-supplies.ruedata.com/api/v1";

const client = axios.create({
  baseURL: apiURL,
  json: true,
});

export default {
  async execute(method, resource, data) {
    const req = await client({
      method: method,
      url: resource,
      data: data,
      headers: {},
    });

    return req.data;
  },

  createOdometer(data) {
    return this.execute("post", `/odometer/`, data);
  },

  getOdometersByVehicle(customer_id, id) {
    return this.execute(
      "get",
      `/odometer?customer=${customer_id}&vehicle=${id}`
    );
  },

  addOdomoterToVehicle(data) {
    return this.execute("post", "/odometer-vehicle/", data);
  },

  getOdometersByCustomer(customer) {
    return this.execute("get", `/odometer?customer=${customer}`);
  },

  getHistoryByOdometer(id) {
    return this.execute("get", `/odometer-historical?odometer=${id}`);
  },

  restoreOdometer(id, data) {
    return this.execute("put", `/odometer/${id}/`, data);
  },

  restoreOdometerByVehicle(id, data) {
    return this.execute("put", `/restart-km-vehicle/${id}/`, data);
  },

  getProviders(id) {
    return this.execute("get", `/provider/?client_id=${id}`);
  },

  getProvidersById(customer_id, id) {
    return this.execute("get", `/provider/${id}/?client_id=${customer_id}`);
  },

  updateProvidersById(id, data) {
    return this.execute(
      "put",
      `/provider/${id}/?client_id=${data.client.id}`,
      data
    );
  },

  removeProvidersById(customer_id, id) {
    return this.execute("delete", `/provider/${id}/?client_id=${customer_id}`);
  },

  createProvider(data) {
    return this.execute("post", `/provider/`, data);
  },
};
